import { Navigate, RouteObject } from "react-router-dom";

import { PermissionedRoutes } from "../../components/PermissionedRoutes";

export const CONVERSION_PORTAL_ROUTES: RouteObject[] = [
  {
    element: (
      <PermissionedRoutes
        requiredFeatures={["conversion_portal"]}
        requiredPermissions={["backoffice.use_conversion_portal"]}
      />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="home" replace />,
      },
      {
        path: "home",
        async lazy() {
          const { Home } = await import("./Home");
          return { element: <Home /> };
        },
      },
      {
        path: "users",
        async lazy() {
          const { Users } = await import("./Users");
          return { element: <Users /> };
        },
      },
      {
        path: "exclusions",
        async lazy() {
          const { Exclusions } = await import("./Exclusions");
          return { element: <Exclusions /> };
        },
      },
      {
        path: "exclusions/:issueUuid",
        async lazy() {
          const { UserIssues } = await import("./UserIssues");
          return { element: <UserIssues /> };
        },
      },
      {
        path: "issues",
        async lazy() {
          const { Issues } = await import("./Issues");
          return { element: <Issues /> };
        },
      },
      {
        path: "issues/:issueUuid",
        async lazy() {
          const { UserIssues } = await import("./UserIssues");
          return { element: <UserIssues /> };
        },
      },
    ],
  },
];
